// extracted by mini-css-extract-plugin
export default {"tabContent":"TabContent_tabContent__q5anN"};